import React, { useState, useEffect } from 'react';
import { getAvailableConfigs, uploadFile } from '../services/api';

const FileUpload = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [configChoice, setConfigChoice] = useState('CREWS');
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [availableConfigs, setAvailableConfigs] = useState([]);

  const modelConfig = {
    temperature: 0,
    top_p: 0.95,
    top_k: 20,
    max_output_tokens: 8192,
    model_name: "gemini-2.0-flash",
    // model_name: "gemini-2.5-pro-preview-05-06",
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const configs = await getAvailableConfigs();
        if (configs.configs && configs.configs.length > 0) {
          setAvailableConfigs(configs.configs);
        }
      } catch (error) {
        console.error('Error fetching available configs:', error);
      }
    };

    fetchConfigs();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
      setErrorMessage('');
    } else {
      setFile(null);
      setErrorMessage('Please select a PDF file');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setErrorMessage('Please select a file to upload');
      return;
    }

    setIsUploading(true);
    try {
      const response = await uploadFile(file, configChoice, modelConfig);
      onUploadSuccess(response.job_id, configChoice);
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || 'Error uploading file');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="file-upload-container">
      <h2>Upload Project Document</h2>
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label htmlFor="file-input">Select PDF File:</label>
          <input
            id="file-input"
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            disabled={isUploading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="config-select">Select Configuration:</label>
          <select
            id="config-select"
            value={configChoice}
            onChange={(e) => setConfigChoice(e.target.value)}
            disabled={isUploading}
          >
            {availableConfigs.length > 0 ? (
              availableConfigs.map((config) => (
                <option key={config.id} value={config.id}>
                  {config.name}
                </option>
              ))
            ) : (
              <>
                <option value="CREWS">CREWS Configuration</option>
                <option value="AF">Adaptation Fund (AF) Configuration</option>
                <option value="GCF">Green Climate Fund (GCF) Configuration</option>
                <option value="GEF">Global Environment Facility (GEF) Configuration</option>
                <option value="WB">World Bank (WB) Configuration</option>
                <option value="SOFF">Systematic Observations Financing Facility (SOFF) Configuration</option>



              </>
            )}
          </select>
        </div>

        <div className="form-group">
          <h3>Model Settings</h3>
          <p>Using default settings for best results. The analysis may take a few minutes to complete.</p>
        </div>

        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <button 
          type="submit" 
          className="submit-button" 
          disabled={!file || isUploading}
        >
          {isUploading ? 'Uploading...' : 'Analyze Document'}
        </button>
      </form>
    </div>
  );
};

export default FileUpload;
